import { render, staticRenderFns } from "./finishedDetails.vue?vue&type=template&id=316d4318&"
import script from "./finishedDetails.vue?vue&type=script&lang=js&"
export * from "./finishedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports